import type { app } from "@be/app";
import { hc } from "hono/client";

/** Hono client to be used by Frontend */
export const Client = (...args: Parameters<typeof hc>) =>
	hc<typeof app>(...args);
